<template>
	<div class="app-content">
		<Content class="app-content__main">
			<h1>欢迎使用九罗管理系统</h1>
		</Content>
		<Upload action="http://60.172.131.38:8091/advert-data/monthDataCount" name="excel" :on-success="exportExcel">
			<Button icon="ios-cloud-upload-outline">对比上传</Button>
		</Upload>
	</div>
</template>
<script>
	export default {
		methods: {
			exportExcel(response, file, fileList) {
				window.location.href = response.data
			},
		}
	}
</script>